<template>
  <div class="service-book-dashboard px-0 ml-md-3">
    <div class="card-custom gutter-b">
      <!-- <div class="card-header border-0 pt-6 pb-2 d-flex justify-content-between align-items-center">
        <h3 class="card-title align-items-start flex-column mb-0">
          <span class="card-label font-weight-bolder text-dark">My Service Records</span>
          <span class="text-muted mt-1 font-weight-bold font-size-sm">Your detailed service history</span>
        </h3>
        <div class="card-toolbar">
           <b-dropdown variant="primary" toggle-class="border rounded bg-light py-1 px-2" right>
            <template #button-content><i class="far fa-file-pdf px-1"></i> Download My Service Book</template>
            <b-dropdown-item @click="handleDownload('both')">Bangla & English</b-dropdown-item>
            <b-dropdown-item @click="handleDownload('bn')">Bangla Only</b-dropdown-item>
            <b-dropdown-item @click="handleDownload('en')">English Only</b-dropdown-item>
          </b-dropdown>
        </div>
      </div> -->

        <!-- <div class="mt-4 employee-tab leave-attendance-dashboard mx-3">
            <div class="col-md-12 custom-tab-nav ml-auto pl-0 bg-white">
            <ul class="nav nav-pills leave-attendance-dashboard-tab">
                <li class="nav-item" style="margin-right: .5%">
                <a class="nav-link" :class="{ active: activeTab === 'identification' }" @click="activeTab = 'identification'" href="javascript:void(0);">
                    <span class="nav-text font-weight-bolder">Identification</span>
                    <span class="nav-subtext bn-text">পরিচয়ানুমূলক তথ্য</span>
                </a>
                </li>
                <li class="nav-item" style="margin-right: .5%">
                <a class="nav-link" :class="{ active: activeTab === 'employment' }" @click="activeTab = 'employment'" href="javascript:void(0);">
                    <span class="nav-text font-weight-bolder">Employment</span>
                    <span class="nav-subtext bn-text">চাকরির তথ্য</span>
                </a>
                </li>
                <li class="nav-item" style="margin-right: .5%">
                <a class="nav-link" :class="{ active: activeTab === 'service-wages' }" @click="activeTab = 'service-wages'" href="javascript:void(0);">
                    <span class="nav-text font-weight-bolder">Wages</span>
                    <span class="nav-subtext bn-text">মজুরি ও ভাতা</span>
                </a>
                </li>
                <li class="nav-item" style="margin-right: .5%">
                <a class="nav-link" :class="{ active: activeTab === 'leave' }" @click="activeTab = 'leave'" href="javascript:void(0);">
                    <span class="nav-text font-weight-bolder">Leave</span>
                    <span class="nav-subtext bn-text">ছুটির রেকর্ড</span>
                </a>
                </li>
                <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'behavioral' }" @click="activeTab = 'behavioral'" href="javascript:void(0);">
                    <span class="nav-text font-weight-bolder">Behavioral</span>
                    <span class="nav-subtext bn-text">আচরণিক রেকর্ড</span>
                </a>
                </li>
            </ul>
            </div>
        </div>

        <div class="card-body">
            <div class="tab-content">
            <div v-if="activeTab === 'identification'">
                <service-book-front-worker-identification-document ref="identification"></service-book-front-worker-identification-document>
            </div>
            <div v-else-if="activeTab === 'employment'">
                <service-book-front-employer-and-employment-details ref="employment"></service-book-front-employer-and-employment-details>
            </div>
            <div v-else-if="activeTab === 'service-wages'">
                <service-book-front-service-wages-and-allowance-record ref="wages"></service-book-front-service-wages-and-allowance-record>
            </div>
            <div v-else-if="activeTab === 'leave'">
                <service-book-front-service-leave-record ref="leave"></service-book-front-service-leave-record>
            </div>
            <div v-else-if="activeTab === 'behavioral'">
                <service-book-front-service-behavioral-record ref="behavioral"></service-book-front-service-behavioral-record>
            </div>
            </div>
        </div> -->

        <!-- Mustafijur: 20-05-2026: Strats -->

        <div class="row no-gutters py-2 mb-3">
            <div class="col-md-8 col-sm-12" >
                <h4 class="atlhr-dashboard-title mt-10">
                    Service <span class="black-title">Book</span>
                    <span>
                        <a v-bind:href="$api_url">Dashboard</a>  / Profile  / Service Book
                    </span>
                </h4>
            </div>
        </div>

        <div class="service-book-tab-title row no-gutters py-2 mb-3">
            <div class="col-md-8 col-sm-12" >
                <h3 class="card-title align-items-start flex-column mb-0">
                    <span class="card-label font-weight-bolder text-dark">My Service Records</span>
                    <span class="text-muted mt-1 font-weight-bold font-size-sm">Your detailed service history</span>
                </h3>
            </div>
            <div class="col-sm-4 text-right px-3 d-flex align-items-center justify-content-center justify-content-sm-end mt-4 mt-sm-0">
                <b-dropdown variant="primary" toggle-class="border rounded bg-light py-1 px-2" right>
                    <template #button-content><i class="far fa-file-pdf px-1"></i> Download My Service Book</template>
                    <b-dropdown-item @click="handleDownload('both')">Bangla & English</b-dropdown-item>
                    <b-dropdown-item @click="handleDownload('bn')">Bangla Only</b-dropdown-item>
                    <b-dropdown-item @click="handleDownload('en')">English Only</b-dropdown-item>
                </b-dropdown>
                <!-- Added by Tareq Sifat 2026-08-02 — the printable booklet, the same saddle-stitched
                     layout the Employee Management page exports in bulk. Bangla and English only:
                     the bilingual variant does not fit the booklet's A5 half-page. -->
                <b-dropdown variant="primary" toggle-class="border rounded bg-light py-1 px-2" right class="ml-2">
                    <template #button-content><i class="far fa-file-pdf px-1"></i> Download Booklet</template>
                    <b-dropdown-item @click="handleBookletDownload('bn')">Bangla Only</b-dropdown-item>
                    <b-dropdown-item @click="handleBookletDownload('en')">English Only</b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="mt-4 employee-tab leave-attendance-dashboard employee-investment-wrapper">
            <b-tabs pills content-class="" nav-class=" pr-2 m-2 leave-attendance-dashboard-tab" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">

                <template >
                    <b-tab lazy>
                        <template active v-slot:title>
                            <span class="nav-text font-weight-bolder">Worker Identification</span>
                            <span class="nav-subtext bn-text">শ্রমিকের সনাক্তকরনের তথ্য</span>
                        </template>
                        <div class="tab-item-wrapper">
                            <service-book-front-worker-identification-document ref="identification"></service-book-front-worker-identification-document>
                        </div>
                    </b-tab>
                    <b-tab lazy>
                        <template active v-slot:title>
                            <span class="nav-text font-weight-bolder">Employment details</span>
                            <span class="nav-subtext bn-text">চাকরির তথ্য</span>
                        </template>
                        <div class="tab-item-wrapper">
                            <service-book-front-employer-and-employment-details ref="employment"></service-book-front-employer-and-employment-details>
                        </div>
                    </b-tab>
                    <b-tab lazy>
                        <template active v-slot:title>
                            <span class="nav-text font-weight-bolder">Service, Wages and Allowance</span>
                            <span class="nav-subtext bn-text">সার্ভিস, মজুরি এবং ভাতা</span>
                        </template>
                        <div class="tab-item-wrapper">
                            <service-book-front-service-wages-and-allowance-record ref="wages"></service-book-front-service-wages-and-allowance-record>
                        </div>
                    </b-tab>

                    <b-tab lazy>
                        <template active v-slot:title>
                            <span class="nav-text font-weight-bolder">Leave Record</span>
                            <span class="nav-subtext bn-text">ছুটির রেকর্ড</span>
                        </template>
                        <div class="tab-item-wrapper">
                            <service-book-front-service-leave-record ref="leave"></service-book-front-service-leave-record>
                        </div>
                    </b-tab>

                    <b-tab lazy>
                        <template active v-slot:title>
                            <span class="nav-text font-weight-bolder">Behavioral Record</span>
                            <span class="nav-subtext bn-text">আচরণের রেকর্ড</span>
                        </template>
                        <div class="tab-item-wrapper">
                            <service-book-front-service-behavioral-record ref="behavioral"></service-book-front-service-behavioral-record>
                        </div>
                    </b-tab>


                </template>

            </b-tabs>

        </div>
        <!-- Mustafijur: 20-05-2026: Ends -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      apiPrefix: "/front/service-book",
      activeTab: "identification",
    };
  },
  methods: {
    handleDownload(lang = "both") {
       // Using the generic download all endpoint for the logged in employee
       axios.post(this.$api_url + this.apiPrefix + "/download-all-pdf", { lang: lang }, { responseType: "blob" })
        .then((response) => { this.global_download_file_content(response); });
    },
    // Added by Tareq Sifat 2026-08-02 — booklet counterpart of handleDownload. The endpoint takes
    // the employee from the session, so the request carries nothing but the language.
    handleBookletDownload(lang = "bn") {
       axios.post(this.$api_url + this.apiPrefix + "/download-booklet-pdf", { lang: lang }, { responseType: "blob" })
        .then((response) => { this.global_download_file_content(response); });
    }
  }
};
</script>

<style scoped>
/* .service-book-dashboard { background-color: #f4f7f6; } */
.leave-attendance-dashboard-tab .nav-link {
  display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;
  padding: 1rem 0.5rem !important; min-height: 100px; transition: all 0.2s ease-in-out;
}
.ess-portal .leave-attendance-dashboard .nav-link.active::after {
	background: #e1f0ff;
}
.ess-portal .leave-attendance-dashboard .nav-link:hover::after {
	background: #fff;
}
.leave-attendance-dashboard-tab .nav-link:hover {
  background-color: #fff !important;
}
.leave-attendance-dashboard-tab .nav-link.active { background-color: rgba(54, 153, 255, 0.15) !important; color: #3699ff !important; }
.nav-text { font-size: 0.9rem; font-weight: bold; }
.nav-subtext { font-size: 0.75rem; margin-top: 4px; }
.bn-text { font-family: "notosansbengali", sans-serif; }
.nav-item { width: 19% !important; }
</style>
